/**
 * 标题、文案&图标映射
 */
import useI18n from '@/i18n/landing'
import { getStore } from '@/store/store-standard'
import { Tracker } from '@/utils/event-lib'
const i18n = useI18n()

const mapping: {
  [key: string]: {
    title: string
    content: string
    icon: string
    button: string
    // 埋点函数
    track: (sw?: boolean) => void
  }
} = {
  /**
   * 活动结束页面
   */
  mgm_overdue: {
    title: i18n.t('Fintech_Credit_MGM_dCnh_VUbF'),
    content: i18n.t('Fintech_Credit_MGM_jRsA_aJyu'),
    icon: require('@/assets/images/icon-gift.png'),
    button: i18n.t('Fintech_Credit_MGM_YitB_QNUR'),
    track(sw = true) {
      Tracker.trackWithMgm(
        sw
          ? 'fin_loan_mgm_campaign_timeout_sw'
          : 'fin_loan_mgm_campaign_timeout_ck',
        {
          error_type: '活动已结束',
        }
      )
    },
  },
  /**
   * 不符合参加条件
   * @note 未登录
   */
  mgm_reject_1: {
    title: i18n.t('Fintech_Credit_MGM_zPxE_bpxU'),
    content: '',
    icon: require('@/assets/images/app-thb.png'),
    button: '',
    track(sw = true) {
      Tracker.trackWithMgm(
        sw
          ? 'fin_loan_mgm_campaign_timeout_sw'
          : 'fin_loan_mgm_campaign_timeout_ck',
        {
          error_type: '不符合条件',
        }
      )
    },
  },
  /**
   * 不符合参加条件
   * @note 已登录
   */
  mgm_reject_2: {
    title: i18n.t('Fintech_Credit_MGM_zPxE_bpxU'),
    get content() {
      const user = getStore('user')
      const cell = user?.cell
      const phone_number = cell ? `+52 ${cell}` : ''
      return `
      <p>${i18n.t('Fintech_Credit_MGM_KdwC_pihh', {
        phone_number,
      })}</p>
      <p><a href="javascript:void(0)" )" onclick="location.reload()">${i18n.t(
        'Fintech_Credit_MGM_wkzA_UVSR'
      )}</a></p>
    `
    },
    icon: require('@/assets/images/app-thb.png'),
    button: i18n.t('Fintech_Credit_MGM_MVYs_hWXy'),
    track(sw = true) {
      Tracker.trackWithMgm(
        sw
          ? 'fin_loan_mgm_campaign_timeout_sw'
          : 'fin_loan_mgm_campaign_timeout_ck',
        {
          error_type: '绑定自己',
        }
      )
    },
  },
  /**
   * 被拒用户页面/M1风控页面
   */
  mgm_risk: {
    title: i18n.t('Fintech_Credit_MGM_zPxE_bpxU'),
    content: '',
    icon: require('@/assets/images/app-thb.png'),
    button: '',
    track(sw = true) {
      Tracker.trackWithMgm(
        sw
          ? 'fin_loan_mgm_campaign_timeout_sw'
          : 'fin_loan_mgm_campaign_timeout_ck',
        {
          error_type: '风控拦截',
        }
      )
    },
  },
  /**
   * 老用户无法领券页
   */
  mgm_old: {
    title: i18n.t('Fintech_Credit_MGM_FRze_wbCU', {
      brandname1: i18n.t('financial.loan.freya.brand.name'),
    }),
    get content() {
      const { cell } = getStore('user')
      const phone_number = cell ? `+52 ${cell}` : ''
      return `
      <p>${i18n.t('Fintech_Credit_MGM_KdwC_pihh', {
        phone_number,
      })}</p>
      <p><a href="javascript:void(0)" )" onclick="location.reload()">${i18n.t(
        'Fintech_Credit_MGM_wkzA_UVSR'
      )}</a></p>
    `
    },
    icon: require('@/assets/images/app-thb.png'),
    button: i18n.t('Fintech_Credit_MGM_MVYs_hWXy'),
    track(sw = true) {
      Tracker.trackWithMgm(
        sw
          ? 'fin_loan_mgm_campaign_timeout_sw'
          : 'fin_loan_mgm_campaign_timeout_ck',
        {
          error_type: '老用户',
        }
      )
    },
  },
  /**
   * 授信等待
   */
  waiting: {
    title: i18n.t('Fintech_Credit_process_HZXM_aphO', {
      number: '10',
    }),
    content: i18n.t('Fintech_Credit_process_HYaW_sMHh'),
    icon: require('@/assets/images/app-thb.png'),
    button: i18n.t('Fintech_Credit_process_Hxcn_fgVI'),
    track(sw = true) {
      Tracker.trackWithMgm(
        sw
          ? 'fin_loan_mgm_campaign_timeout_sw'
          : 'fin_loan_mgm_campaign_timeout_ck',
        {
          error_type: '授信等待',
        }
      )
    },
  },
  /**
   * 授信拒绝
   */
  reject: {
    title: i18n.t('Fintech_Credit_process_vJez_RxPi'),
    content: i18n.t('Fintech_Credit_process_Guey_Ppwk', {
      number: '3',
    }),
    icon: require('@/assets/images/app-thb.png'),
    button: i18n.t('Fintech_Credit_process_Hxcn_fgVI'),
    track(sw = true) {
      Tracker.trackWithMgm(
        sw
          ? 'fin_loan_mgm_campaign_timeout_sw'
          : 'fin_loan_mgm_campaign_timeout_ck',
        {
          error_type: '授信拒绝',
        }
      )
    },
  },
  /**
   * 默认兜底
   */
  default: {
    title: i18n.t('Fintech_Credit_process_FLYH_ptUA'),
    content: i18n.t('Fintech_Credit_process_Guey_Ppwk', {
      number: '3',
    }),
    icon: require('@/assets/images/app-thb.png'),
    button: i18n.t('Fintech_Credit_process_Hxcn_fgVI'),
    track(sw = true) {
      Tracker.trackWithMgm(
        sw
          ? 'fin_loan_mgm_campaign_timeout_sw'
          : 'fin_loan_mgm_campaign_timeout_ck',
        {
          error_type: '维护页',
        }
      )
    },
  },
}

export default mapping
